document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("dp-popup");

    if (!popup) return;

    const overlay = popup.querySelector(".dp-overlay");

    const modal = popup.querySelector(".dp-modal");

    const closeBtn = popup.querySelector(".dp-close");

    const form = document.getElementById("discount-popup-form");

    const submitBtn = popup.querySelector(".dp-submit");

    const formWrapper = document.getElementById("dp-form-wrapper");

    const successWrapper = document.getElementById("dp-success");

    const emailField = document.getElementById("dp-email");

    const errorBox = popup.querySelector(".dp-error");


    const SESSION_KEY = "discount_popup_" + popup.dataset.productId;

    if(sessionStorage.getItem(SESSION_KEY)){

        return;

    }

    const url = new URL(window.location);

    const success =
        url.searchParams.get("popup_success");

    if (window.location.search.includes("popup_success=true")) {

    popup.classList.add("is-visible");

    popup.setAttribute("aria-hidden","false");

    formWrapper.style.display = "none";

    successWrapper.style.display = "block";

    document.body.style.overflow = "hidden";

    setTimeout(function(){

        popup.classList.remove("is-visible");

        document.body.style.overflow = "";

    },10000);

    const cleanUrl = window.location.pathname;

    window.history.replaceState({},document.title,cleanUrl);

    return;
}



    const SHOW_DELAY = 1500;

    setTimeout(() => {

        popup.classList.add("is-visible");

        popup.setAttribute("aria-hidden", "false");

        document.body.style.overflow = "hidden";

    }, SHOW_DELAY);





 

    function closePopup() {

        popup.classList.remove("is-visible");

        popup.setAttribute("aria-hidden", "true");

        document.body.style.overflow = "";

        sessionStorage.setItem(

SESSION_KEY,

"closed"

);

    }



    closeBtn.addEventListener(

        "click",

        closePopup

    );



    overlay.addEventListener(

        "click",

        closePopup

    );



    document.addEventListener(

        "keydown",

        (event) => {

            if (

                event.key === "Escape" &&

                popup.classList.contains("is-visible")

            ) {

                closePopup();

            }

        }

    );





    form.addEventListener(

        "submit",

        (event) => {

            errorBox.style.display = "none";



            if (

                emailField.value.trim() === ""

            ) {

                event.preventDefault();

                errorBox.innerHTML =
                    "Please enter your email.";

                errorBox.style.display = "block";

                return;

            }



            submitBtn.disabled = true;

            submitBtn.innerHTML = "Sending...";

        }

    );

});